import React, {
  FC,
  FormEvent,
  useCallback,
  useState,
  useEffect,
  useRef,
} from 'react'

import * as SC from './styled'

export type HeaderSearchProps = {
  placeholder: string
  onSearch: (search: string) => void
  searchText: string
  onReady?: (input: HTMLInputElement) => void
  className?: string
}

const HeaderSearch: FC<HeaderSearchProps> = (props) => {
  const { placeholder, onSearch, searchText, className = '', onReady } = props
  const [inputValue, setInputValue] = useState('')

  const inputRef = useRef<HTMLInputElement>(null)

  const onSubmit = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault()
      onSearch(inputValue)
    },
    [inputValue, onSearch]
  )

  useEffect(() => {
    if (!inputRef.current || !onReady) {
      return
    }
    onReady(inputRef.current)
  }, [onReady])

  return (
    <SC.HeaderSearch className={className}>
      <SC.HeaderSearchContent>
        <SC.Form onSubmit={onSubmit}>
          <SC.InputWrapper>
            <SC.Svg icon="search" />
            <SC.Input
              ref={inputRef}
              placeholder={placeholder}
              value={inputValue}
              onChange={({ target }) => setInputValue(target.value)}
            />
          </SC.InputWrapper>
          <SC.Button
            text={searchText}
            variantType="button"
            variantColorScheme="black"
            actionProps={{}}
          />
        </SC.Form>
      </SC.HeaderSearchContent>
    </SC.HeaderSearch>
  )
}

export default HeaderSearch
